import React from "react";
import "./dashboard-empty.css";
import Emptystate from "../../../images/new-images/empty-state.svg";
import { Link } from "react-router-dom";

export const Dashboardempty = (props) => {
  return (
    <React.Fragment>
      <div className="dashboard-empty-wrapper">
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img className="img" src={Emptystate} alt="Empty State Image" />
        </div>
        <h5 className="There-is-nothing-in-here">
          There is nothing in here :(
        </h5>
        <p className="Start-building-your-Dashboard">
          Start building your Dashboard
        </p>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {props.instrument_id?
          <Link
            to={{
              pathname: `/new/app/welcome/${props.instrument_id}/${props.id}/${props.orgId}/${props.sellerId}/${props.participant_id}/${props.multi_rater}/${props.assessmentCompletedCount}/${props.assessmentType}`,
            }}
          >
            <button className="begin-button">BEGIN QUESTIONNAIRE</button>
          </Link>:
             <Link
             to={{
               pathname: `/new/app/dashBoard`,
             }}
           >
             <button className="begin-button">BEGIN QUESTIONNAIRE</button>
           </Link>
          }
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/new/Dashboard/Dashboard-empty/dashboard-empty.jsx